import { render, staticRenderFns } from "./ScreenTimeChart.vue?vue&type=template&id=b6fabd1e&scoped=true&"
import script from "./ScreenTimeChart.vue?vue&type=script&lang=js&"
export * from "./ScreenTimeChart.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTimeChart.vue?vue&type=style&index=0&id=b6fabd1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fabd1e",
  null
  
)

export default component.exports